import './App.css';
import ArticlesList from './Article';

function App() {
  return (
    <>
      
      <ArticlesList/>
    </>
        
  );
}

export default App;
